import {
  getPdfOutlineUnits,
  type PdfOutlineUnit,
} from 'features/knowledgeDocumentViewer/utils/pdfOutlineUnits'
import { useEffect, useState } from 'react'

type PdfOutlineUnitsResult = {
  units: PdfOutlineUnit[]
  isLoading: boolean
}

/** Loads PDF outline units when enabled; isLoading is true until the fetch settles. */
export function usePdfOutlineUnits(
  pdfUrl: string | undefined,
  enabled: boolean
): PdfOutlineUnitsResult {
  const [units, setUnits] = useState<PdfOutlineUnit[]>([])
  const [loadedForKey, setLoadedForKey] = useState<string | null>(null)

  const requestKey = enabled && pdfUrl ? pdfUrl : null
  const isLoading = requestKey !== null && loadedForKey !== requestKey

  useEffect(() => {
    if (!requestKey) {
      setUnits([])
      setLoadedForKey(null)
      return
    }

    let cancelled = false
    setUnits([])
    void getPdfOutlineUnits(requestKey).then((nextUnits) => {
      if (!cancelled) {
        setUnits(nextUnits)
        setLoadedForKey(requestKey)
      }
    })
    return () => {
      cancelled = true
    }
  }, [requestKey])

  return { units, isLoading }
}
